import React, { useEffect, useState } from "react";
import "./CompletionCard.scss";
import { Card, CardContent } from "@material-ui/core";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import { badgeRange } from "../../../globalConstants";
import DialogComponent from "../DialogComponent/DialogComponent";

const BadgeContent = (props: any) => {
  const allInfo = useSelector((state: any) => state);
  const [loaderFlag, setLoaderFlag] = useState(false);
  const [displayBadge, setDisplayBadge] = useState(false);
  const [licenseType] = useState(String(window.location.href.split("/")[4]) || allInfo.common.productID);
  const [openDialog, setOpenDialog] = useState(false);
  let totalSuccessScore = 0;
  let averageSuccess = 0;
  let levelString = "";
  const firstCharHelper = (inputString: string) => {
    return inputString
      .split(/\s/)
      .reduce((response: any, word: any) => (response += word.slice(0, 1)), "")
      .toLowerCase();
  };
  const [badgeURL, setBadgeURL] = useState("");
  const handleClose=()=> {
    setOpenDialog(false);
  }
  useEffect(() => {
    if (
      !!allInfo.skillOutcomeSummary.data &&
      !!allInfo.skillOutcomeSummary.data.skillOutcomeSummary &&
      allInfo.skillOutcomeSummary.data.skillOutcomeSummary.length > 0 &&
      !!props.cardData &&
      !!allInfo.common.productID &&
      !!allInfo.currentCourseDetails.data
    ) {
      let skillOutcomeData = allInfo.skillOutcomeSummary.data.skillOutcomeSummary;
      if (licenseType === "20") {
        if (
          !!allInfo.currentCourseDetails.data.Completed[props.partTitle] &&
          allInfo.currentCourseDetails.data.Completed[props.partTitle].length > 0
        ) {
          skillOutcomeData = skillOutcomeData.map((item: any) => Object.assign({}, item, { coursePartTitle: "" }));
          for (let i = 0; i < skillOutcomeData.length; i++) {
            for (let j = 0; j < allInfo.currentCourseDetails.data.Completed[props.partTitle].length; j++) {
              if (
                skillOutcomeData[i].skillTitle ===
                allInfo.currentCourseDetails.data.Completed[props.partTitle][j].ModuleName
              ) {
                skillOutcomeData[i].coursePartTitle =
                  allInfo.currentCourseDetails.data.Completed[props.partTitle][j].CoursePart;
              }
            }
          }
          skillOutcomeData = skillOutcomeData.filter(
            (filterData: { coursePartTitle: String }) => filterData.coursePartTitle === props.partTitle
          );
        }
      } else {
        setDisplayBadge(
          !!allInfo.currentCourseDetails.data.Completed.skill &&
            allInfo.currentCourseDetails.data.Completed.skill.filter(
              (data: any) => data.ModuleName === props.cardData.name
            )
        );
      }
      if (skillOutcomeData.length > 0) {
        skillOutcomeData.map((skillData: any) => {
          totalSuccessScore += Number(skillData.skillSummary[0].sucessScore);
        });
      }
      if (licenseType === "20") {
        averageSuccess = totalSuccessScore / Number(props.cardData.units.length);
      } else if (licenseType === "18") {
        averageSuccess = totalSuccessScore / Number(props.cardData.totalsessions);
      }
      if (averageSuccess > 0 && !!displayBadge) {
        badgeRange.map((badgeInfo: any) => {
          if (badgeInfo.min <= averageSuccess) {
            if (licenseType === "20") {
              levelString = (props.cardData.level.slice(0, 1) + props.cardData.level.slice(1)).replace(".", "-");
              const badgeURL =
                process.env["REACT_APP_ASSETS_URL"] +
                "/halo/badges/business-english/sprint-be-" +
                badgeInfo.type.charAt(0) +
                "-" +
                levelString +
                "-" +
                "part-" +
                props.partTitle +
                ".svg";
              setBadgeURL(badgeURL.toLowerCase());
            } else if (licenseType === "18") {
              levelString =
                badgeInfo.type.charAt(0).toLowerCase() +
                "-" +
                firstCharHelper(props.cardData.name) +
                "-" +
                firstCharHelper(allInfo.currentCourseDetails.data.Level);
              setBadgeURL(
                process.env["REACT_APP_ASSETS_URL"] +
                  "/halo/badges/business-skills/sprint-bskills-ss-" +
                  levelString +
                  ".svg"
              );
            }
          }
        });
      }
    }
  }, [
    allInfo.skillOutcomeSummary,
    props.cardData.totalsessions,
    allInfo.common.productID,
    allInfo.currentCourseDetails,
    displayBadge
  ]);

  useEffect(() => {
    setTimeout(() => {
      setLoaderFlag(false);
    }, 1000);
  }, [badgeURL]);

  return (
    <React.Fragment>
      <Card className="completion-card no-shadow general-clickable" onClick={()=> setOpenDialog(true)}>
        <CardContent className="completion-card-body">
          <div>
            <Loader showLoader={loaderFlag} />
            <div>
              <div>
                <div >
                  {!!!badgeURL && !!!sessionStorage.getItem("isDemoUser") && (
                    <img src={"../../../images/badge/badge-placeholder.svg"} className={"badge-placeholder"} />
                  )}
                  {!!badgeURL && !!!sessionStorage.getItem("isDemoUser") && (
                    <img src={badgeURL} className={"overall-badge"} />
                  )}
                  {!!sessionStorage.getItem("isDemoUser") && licenseType === "20" && (
                    <img
                      src={"https://assets.learnship.today/halo/badges/business-english/sprint-be-g-b2-1-part-a.svg"}
                      className={"overall-badge"}
                    />
                  )}
                    {!!!badgeURL &&  (licenseType === "21" || licenseType === "22"  || licenseType === "23"  || licenseType === "24") && (
                       <img src={"../../../images/badge/badge-placeholder.svg"} className={"badge-placeholder"} />
                   )}
                  {!!sessionStorage.getItem("isDemoUser") && licenseType === "18" && (
                    <img
                      src={
                        "https://assets.learnship.today/halo/badges/business-skills/sprint-bskills-ss-b-" +
                        `${firstCharHelper(props.cardData.name)}` +
                        "-" +
                        "hi" +
                        ".svg"
                      }
                      className={"overall-badge"}
                    />
                  )}
                  {!!!badgeURL && !!!sessionStorage.getItem("isDemoUser") && (
                    <img src={"../../../images/cert-badge-lock.svg"} className={"lock-icon"}  onClick={()=>setOpenDialog(true)} />
                  )}
                    {!!!badgeURL &&  (licenseType === "21" || licenseType === "22"  || licenseType === "23"  || licenseType === "24") && (
                    <img src={"../../../images/cert-badge-lock.svg"} className={"lock-icon"}  onClick={()=>setOpenDialog(true)} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      {openDialog && !!props.dialogContent && (
                    <DialogComponent openDialog={openDialog} title={""} handleClose={handleClose}>
                      {props.dialogContent}
                    </DialogComponent>
                  )}
    </React.Fragment>
  );
};

export default BadgeContent;
